module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="team-info-header">\n	<figure>\n		<img src="'+
((__t=( avatar_url ))==null?'':_.escape(__t))+
'" alt="">\n	</figure>\n	<h3>'+
((__t=( name ))==null?'':_.escape(__t))+
'</h3>\n</div>\n<div class="team-filed-list">\n	<header class="team-filed-list-header">\n		<span class="column column-first">Select Player To Trade Out</span>\n	</header>\n	';
 _.size(positions_by_id) && _.each(lineup, function(field_row, pos_id) {  
__p+='\n		';
 _.each(field_row, function(player, index){ 
__p+='\n			';
 if(pos_id === 'bench' && index === 0){ 
__p+='\n				<header class="team-filed-list-header">\n					<span class="column column-first">BENCH</span>\n				</header>\n			';
 } 
__p+='\n\n			';
 if(player.id){ 
__p+='\n				<div class="player-cell '+
((__t=( player.substitute_class_name ))==null?'':_.escape(__t))+
' '+
((__t=( player.leader_class_name ))==null?'':_.escape(__t))+
' '+
((__t=( pos_id === 'bench' ? 'player-cell-bench' : '' ))==null?'':_.escape(__t))+
' '+
((__t=( swap_player.id === player.id ? 'is-swappable' : '' ))==null?'':_.escape(__t))+
'"\n				     data-player-id="'+
((__t=( player.id ))==null?'':_.escape(__t))+
'"\n				     data-position-id="'+
((__t=( pos_id ))==null?'':_.escape(__t))+
'"\n				     data-index="'+
((__t=( index ))==null?'':_.escape(__t))+
'">\n					<div class="column column-first">\n						';
 if(pos_id !== 'bench'){ 
__p+='\n							<div class="field-position-name">\n								<div class="field-position-label">\n									<span>'+
((__t=( _.result(positions_by_id, pos_id, {}).short_name ))==null?'':_.escape(__t))+
'</span>\n								</div>\n							</div>\n						';
 } else { 
__p+='\n							<div class="bench-position-type '+
((__t=( index < 4 ? 'interchange' : 'emergencies' ))==null?'':_.escape(__t))+
'">\n								<div class="bench-position-label">\n									<span>'+
((__t=( index < 4 ? 'INT' : 'EMG' ))==null?'':_.escape(__t))+
'</span>\n									<i class="bench-index">'+
((__t=( index + 1 ))==null?'':_.escape(__t))+
'</i>\n								</div>\n							</div>\n						';
 } 
__p+='\n						<figure>\n							<picture>\n								<source	srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100, format:'webp' }) ))==null?'':_.escape(__t))+
'" type="image/webp" />\n								<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 100 }) ))==null?'':_.escape(__t))+
'"\n								     alt="'+
((__t=( player.first_name + ' ' + player.last_name ))==null?'':_.escape(__t))+
'">\n							</picture>\n						</figure>\n						<div class="player-info">\n							<div class="player-name">\n								<i class="icon player-status '+
((__t=( player.status ))==null?'':_.escape(__t))+
'"></i>\n								<span>'+
((__t=( player.first_name[0] ))==null?'':_.escape(__t))+
'. '+
((__t=( player.last_name ))==null?'':_.escape(__t))+
'</span>\n								';
 if(player.leader_class_name){ 
__p+='\n									<i class="icon player-status player-lead-status '+
((__t=( player.leader_class_name ))==null?'':_.escape(__t))+
'"></i>\n								';
 } 
__p+='\n							</div>\n							<div class="player-stats">\n								<span class="player-opponent">\n									<b>'+
((__t=( player.squad.short_name ))==null?'':_.escape(__t))+
'</b> '+
((__t=( player.opponents.symbol ))==null?'':_.escape(__t))+
' '+
((__t=( player.opponent.short_name ))==null?'':_.escape(__t))+
'\n								</span>\n								<span> | </span>\n								<span class="player-positions">\n									'+
((__t=( player.position_names.join(', ') ))==null?'':_.escape(__t))+
'\n								</span>\n								<br>\n								<span class="player-cost">\n									'+
((__t=( _.currencyFormat(player.cost) ))==null?'':_.escape(__t))+
'\n								</span>\n								<span>&nbsp;|&nbsp;</span>\n								<span class="'+
((__t=( player.cost_season_diff > 0 ? 'positive' : '' || player.cost_season_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n									'+
((__t=( _.currencyFormat(player.cost_season_diff, '$', true) ))==null?'':_.escape(__t))+
'\n								</span>\n								<span> </span>\n								(\n								<span class="'+
((__t=( player.cost_round_diff > 0 ? 'positive' : '' || player.cost_round_diff < 0 ? 'negative' : '' ))==null?'':_.escape(__t))+
'">\n									'+
((__t=( _.currencyFormat(player.cost_round_diff, '$', true) ))==null?'':_.escape(__t))+
'\n								</span>\n								)\n							</div>\n						</div>\n					</div>\n					';
 if(!player.is_locked){ 
__p+='\n						<div class="player-cell-btns">\n							';
 if(player.can_be_swapped){ 
__p+='\n								<a class="icon icon-substitute js-substitute">S</a>\n							';
 } 
__p+='\n							';
 if(!player.is_trade_locked){ 
__p+='\n								<a class="icon icon-trade js-trade">T</a>\n							';
 } 
__p+='\n						</div>\n					';
 } 
__p+='\n					<a class="js-cancel-substitute cancel-substitute">\n						<i class="icon ion-android-close"></i>\n					</a>\n				</div>\n			';
 } else { 
__p+='\n				<div class="player-cell-empty '+
((__t=( swappable_positions.includes(pos_id) ? 'is-accepted-for-swap' : '' ))==null?'':_.escape(__t))+
'" data-position-id="'+
((__t=( pos_id ))==null?'':_.escape(__t))+
'" data-index="'+
((__t=( index ))==null?'':_.escape(__t))+
'">\n					';
 if(pos_id !== 'bench'){ 
__p+='\n						<div class="field-position-name">\n							<div class="field-position-label">\n								<span>'+
((__t=( _.result(positions_by_id, pos_id, {}).short_name ))==null?'':_.escape(__t))+
'</span>\n							</div>\n						</div>\n					';
 } else { 
__p+='\n						<div class="bench-position-type '+
((__t=( index < 4 ? 'interchange' : 'emergencies' ))==null?'':_.escape(__t))+
'">\n							<div class="bench-position-label">\n								<span>'+
((__t=( index < 4 ? 'INT' : 'EMG' ))==null?'':_.escape(__t))+
'</span>\n								<i class="bench-index">'+
((__t=( index + 1 ))==null?'':_.escape(__t))+
'</i>\n							</div>\n						</div>\n					';
 } 
__p+='\n					<div>\n						<span class="player-cell-empty-position">Select a player to trade in</span>\n					</div>\n				</div>\n			';
 } 
__p+='\n		';
 }) 
__p+='\n	';
 })  
__p+='\n</div>';
}
return __p;
};
